import { Label } from '@/components/ui/label'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from '@/components/ui/select'
import { useAppDispatch } from '@/store/hooks'
import { setPageIndex, setPageSize, triggerRefresh } from '@/store/slices/paginationSlice'
import { RootState } from '@/store/store'
import { useSelector } from 'react-redux'

export default function RowPerPage({ tableName }: { tableName: string }) {
    const dispatch = useAppDispatch()
    const { pageSize } = useSelector((state: RootState) => state.pagination[tableName])
    return (<div className="hidden items-center gap-2 lg:flex">
        <Label htmlFor="rows-per-page" className="text-sm font-medium">
            Rows per page
        </Label>
        <Select
            value={`${pageSize}`}
            onValueChange={(value) => {
                dispatch(setPageIndex({ table: tableName, pageIndex: 0 }))
                dispatch(setPageSize({ table: tableName, pageSize: Number(value) }))
                dispatch(triggerRefresh({ table: tableName, isRefresh: true }))
            }}
        >
            <SelectTrigger className="w-20 cursor-pointer" id="rows-per-page">
                <SelectValue
                    placeholder={pageSize}
                />
            </SelectTrigger>
            <SelectContent side="bottom">
                {[10, 25, 50, 100].map((pageSize) => (
                    <SelectItem key={pageSize} value={`${pageSize}`}>
                        {pageSize}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    </div>)
}
